var React = require('react');

function Caret01 (props) {
    return React.createElement("svg",props,React.createElement("path",{"opacity":"0.1","fillRule":"evenodd","clipRule":"evenodd","d":"M39.2371 1.85972L0.752804 20.3698L2.72672 203.046L41.211 184.536L39.75 49.3211L144.472 134.87L182.956 116.36L41.4765 0.782987L39.2371 1.8601L39.2371 1.85972Z","fill":"#9DA4AA"}));
}

Caret01.defaultProps = {"width":"183","height":"204","viewBox":"0 0 183 204","fill":"none"};

module.exports = Caret01;

Caret01.default = Caret01;
